import { useEffect, useState } from 'react';

// Constants
const LOGO_KEY = 'brandingLogo';
const LOGO_API_URL = window.LOGOURL;
const FALLBACK_LOGO = '/peoplehcm-logo.png'; // Path to the fallback logo in the public folder
const isLogoAvailable =
  window.LOGOURL && window.LOGOURL !== 'undefined' && window.LOGOURL !== 'null';

export function useBrandingLogo() {
  const [logo, setLogo] = useState(null);
  const [loading, setLoading] = useState(true); // Loading flag

  useEffect(() => {
    const existingLogo = sessionStorage.getItem(LOGO_KEY);

    if (!isLogoAvailable) {
      setLogo(''); // Set fallback logo if LOGOURL is not available
      setLoading(false); // Set loading to false when fallback logo is used
      return;
    }

    if (existingLogo) {
      setLogo(existingLogo);
      setLoading(false); // Set loading to false when logo is retrieved from sessionStorage
    } else {
      fetch(LOGO_API_URL)
        .then((res) => res.json())
        .then((data) => {
          const base64Logo = data?.data?.LogoBase64;

          if (base64Logo && typeof base64Logo === 'string' && base64Logo.trim() !== '') {
            const formattedLogo = `data:image/png;base64,${base64Logo}`;
            sessionStorage.setItem(LOGO_KEY, formattedLogo);
            setLogo(formattedLogo);
          } else {
            // Use fallback
            // sessionStorage.setItem(LOGO_KEY, FALLBACK_LOGO);
            // setLogo(FALLBACK_LOGO);
          }
        })
        .catch((error) => {
          console.error('Error fetching branding logo:', error);
          // sessionStorage.setItem(LOGO_KEY, FALLBACK_LOGO);
          // setLogo(FALLBACK_LOGO);
        })
        .finally(() => {
          setLoading(false); // Set loading to false after the API call completes
        });
    }
  }, []);

  return { logo, loading, isLogoAvailable }; // Return both logo and loading flag
}
